import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Radio, Stack, TextField, Typography } from "@mui/material";
import { useCallback, useState } from "react";
import { TFiltroCodigoPublico } from "../../../../../../../../types/api/financeiro/detalhar-fechamentos-conta-corrente";
import PaperDraggable from "../../../../../../../../components/PaperDraggable";

export default function CodigosPublicos({
    open,
    defaultValue,
    onClose,
    onSubmitFiltros
}: CodigosPublicosProps) {


    const valorFormSelectInicial =
        typeof defaultValue === "object" && "apenas_os_codigos" in defaultValue && defaultValue.apenas_os_codigos.length > 0
            ? "Apenas os códigos"
            : typeof defaultValue === "object" && "exceto_os_codigos" in defaultValue && defaultValue.exceto_os_codigos.length > 0
                ? "Exceto os códigos"
                : "Todos";

    const valorInternInicial =
        typeof defaultValue === "object" && "apenas_os_codigos" in defaultValue && defaultValue.apenas_os_codigos.length > 0
            ? defaultValue.apenas_os_codigos
            : typeof defaultValue === "object" && "exceto_os_codigos" in defaultValue && defaultValue.exceto_os_codigos.length > 0
                ? defaultValue.exceto_os_codigos
                : [];

    const [formSelect, setFormSelect] = useState<TCodigoPublico>(valorFormSelectInicial);
    const [internFilters, setInternFilters] = useState<number[]>(valorInternInicial);
    const [textField, setTextField] = useState<string>("")
    const dataContent: TCodigoPublico[] = ["Todos", "Apenas os códigos", "Exceto os códigos"]

    const handleClick = ((item: TCodigoPublico) => {
        if (item === 'Todos') {
            setInternFilters([])
        }
        setFormSelect(item)
    });

    const handleSubmit = useCallback(() => {

        let params: TFiltroCodigoPublico = "Todos"
        if (formSelect === 'Apenas os códigos') {
            params = { apenas_os_codigos: internFilters }
        }
        if (formSelect === 'Exceto os códigos') {
            params = { exceto_os_codigos: internFilters }
        }
        onSubmitFiltros(params);
        onClose();
    }, [formSelect, onClose, onSubmitFiltros, internFilters]);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={'xs'}
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
            fullWidth
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Códigos público</DialogTitle>
            <DialogContent>
                <Box display={'flex'} flexDirection={'column'}>
                    {
                        (dataContent && dataContent.length > 0) && dataContent.map((i, index) => {
                            const isChecked = formSelect.includes(i);
                            return (

                                <FormControlLabel
                                    key={index}
                                    onChange={() => handleClick(i)}
                                    control={<Radio checked={isChecked} />}
                                    sx={{ mb: 0 }}
                                    label={
                                        <Box>
                                            <Typography>{`${i}`}</Typography>
                                        </Box>
                                    }
                                />

                            );
                        })
                    }
                    {
                        formSelect === "Apenas os códigos" &&
                        <TextField
                            sx={{ mt: 1.5 }}
                            label="Apenas os códigos"
                            variant="outlined"
                            type="number"
                            helperText="Aperte ENTER para inserir o valor"
                            value={textField}
                            onChange={(event: any) => setTextField(event.target.value)}
                            onKeyDown={(event: any) => {
                                if (event.key === 'Enter') {
                                    const prevValue = internFilters || []
                                    prevValue.push(event.target.value)
                                    setInternFilters(prevValue);
                                    event.target.value = ""
                                    setTextField("")
                                }
                            }}
                        />
                    }
                    {
                        formSelect === "Exceto os códigos" &&
                        <TextField
                            sx={{ mt: 1.5 }}
                            label="Exceto os códigos"
                            variant="outlined"
                            type="number"
                            helperText="Aperte ENTER para inserir o valor"
                            value={textField}
                            onChange={(event: any) => setTextField(event.target.value)}
                            onKeyDown={(event: any) => {
                                if (event.key === 'Enter') {
                                    const prevValue = internFilters || []
                                    prevValue.push(event.target.value)
                                    setInternFilters(prevValue);
                                    event.target.value = ""
                                    setTextField("")
                                }
                            }}
                        />
                    }
                    {
                        (internFilters && internFilters.length > 0) &&
                        <Stack direction="row" flexWrap="wrap" gap={1} spacing={0.5} ml={1} mt={2}>
                            {internFilters.map((i, index: number) => (
                                <Chip label={i} onDelete={() => {
                                    const newValue = internFilters.filter((_, i: number) => i !== index);
                                    setInternFilters(newValue);
                                }} />
                            ))}
                        </Stack>
                    }
                </Box>
            </DialogContent>
            <DialogActions>
                <Box display={'flex'} gap={2}>
                    <Button variant="outlined" onClick={onClose}>
                        Fechar
                    </Button>
                    <Button variant="contained" color="primary" onClick={handleSubmit}>
                        Selecionar
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    )
}

interface CodigosPublicosProps {
    open: boolean
    defaultValue: TFiltroCodigoPublico
    onClose: () => void
    onSubmitFiltros: (value: any) => void
}

type TCodigoPublico = "Todos" | "Apenas os códigos" | "Exceto os códigos"
